import { useAct } from 'FlowBuilder/store'
import AsyncSelect from 'Shared/components/AsyncSelect'

export default function AccessSettingsForm({ actionId }) {
  const act = useAct()
  const surveyAction = useSel((s) => s.actions.entities[actionId])
  const surveyId = surveyAction?.surveyId
  const survey = useSel(s => s.surveys.entities[surveyId])
  const { participationMode, searchId, autoRefreshSearch } = survey || {}

  return (
    <form>
      <div className="field">
        <label>Who can take part?</label>
        <select value={participationMode} onChange={e => act.surveys.upsert(surveyId, { participationMode: e.target.value })}>
          <option key='open' value='open'>Anyone (public)</option>
          <option key='any_target' value='any_target'>Anyone registered in database</option>
          <option key='closed' value='closed'>A specific audience</option>
        </select>
      </div>

      { participationMode === 'closed' && <>
        <div className="field">
          <label>Audience</label>
          <AsyncSelect
            entity="search"
            value={searchId}
            queryParameters={{
              activeOnly: true,
              excludeTemplates: true,
            }}
            onChange={(v) => act.surveys.upsert(surveyId, { searchId: v })}
          />
        </div>

        <div className="field margin-top half">
          <label>When should this audience update?</label>
          <select value={autoRefreshSearch ? 'true' : 'false'} onChange={(e) => act.surveys.upsert(surveyId, { autoRefreshSearch: e.target.value === 'true' })}>
            <option value="true">Update the audience every hour</option>
            <option value="false">Only update the audience if I choose to</option>
          </select>
          <small>When the audience updates it pulls in new people who match the audience, and removes people who no longer match</small>
        </div>
      </> }
    </form>
  )
}
